import React from 'react'
import { useSelector } from 'react-redux';
import { useTranslation, Trans } from "react-i18next";
import { FullWidthCardTemplate, SmallCardTemplate } from '../../../Products/ProductSummaryInsights';
import "../../../../Styles/pages/subscriptionDetail.scss"
import { useDateFormatter } from "../../../../Components/FormatDateTime";
import { CurrencyFormatter, useCurrencyConstants } from '../../../../Components/CurrencyFormatter';

const DetailCard = (props) => {

    const { formatDate, formatDateTime } = useDateFormatter();
    const { currencyFormat, currencySymbol } = useCurrencyConstants();

    const { subscribers, subscriptionSummary } = props
    const defMembership = useSelector((state) => state.defMembership.defMembership);
    const { t } = useTranslation("common");

    const newDate = formatDateTime(props.subscribers?.nextBillingDate)
    const pausedDate = formatDateTime(props.subscribers?.pausedOn)
    const cancelledDate = formatDateTime(props.subscribers?.cancelledOn)
    const failedDate = formatDateTime(props.subscribers?.failedOn)
    const completedDate = formatDateTime(props.subscribers?.completedOn)

    const amount = (props.subscriber?.plan?.flex !== false && props.subscribers?.cost === null)
        ? t("subscriber.flex_true")
        : (CurrencyFormatter({
            amount: props.subscribers?.cost,
            currencySymbol: currencySymbol,
            currencyFormat: currencyFormat,
            as: "string"
        }));

    const subscriptionCreatedOnDate = formatDate(subscribers.createdOn)
    const subscriptionLastModifiedOnDate = formatDate(subscribers.lastModifiedDate)

    const moneyTemplate = (amount = 0, className1 = '', className2 = '') => {
        return (
            <div className='flex'>
                <CurrencyFormatter
                    amount={amount}
                    currencySymbol={currencySymbol}
                    currencyFormat={currencyFormat}
                    symbolClass={className1}
                    valueClass={className2}
                />
            </div>
        )
    }

    const mainCardPlan = [
        {
            page: "subscription-detail",
            subscribers,
            t,
            defMembership,
            subscriptionCreatedOnDate,
            subscriptionLastModifiedOnDate,
        }
    ]

    const smallCardData = [
        {
            title: t("business_customers.total-col-payments"),
            subDesc: t("business_customers.payments"),
            value: <span className='small-card-amt-fig' >{subscriptionSummary?.collectedCount}</span>,
            cardInfo: t("subscriber.tooltip", { status: t("Completed"), subscription: subscribers?.plan?.name }),
            className: "small-card-title"
        },
        {
            title: t("subscriber.total_collected"),
            value: moneyTemplate(subscriptionSummary?.collectedAmount, 'isCollectedCurren', 'isCollected'),
            cardInfo: t("subscriber.tooltip", { status: t("Collected"), subscription: subscribers?.plan?.name }),
            className: "small-card-title"
        },
        {
            title: t("subscriber.total_revenue"),
            value: moneyTemplate(subscriptionSummary?.redeemable, 'isRevenueCurren', 'isRevenue'),
            cardInfo: t("subscriber.tooltip", { status: t("Revenue"), subscription: subscribers?.plan?.name }),
            className: "small-card-title"
        },
        {
            title: t("business_customers.total-mis-payments"),
            subDesc: t("business_customers.payments"),
            value: <span className='amt-fig-red'>{subscriptionSummary?.missedCount}</span>,
            cardInfo: t("subscriber.tooltip", { status: t("Missed"), subscription: subscribers?.plan?.name }),
            className: "small-card-title"
        }
    ]

    return (
        <div className="subscription-detail-cards">
            <div className="grid nested-grid subscription-detail-layout detail_card">
                <section className="col-12 xl:col-9 subscription-detail-main">
                <div className="grid subscription-detail-summary-grid">
                <FullWidthCardTemplate summary={mainCardPlan} />
                </div>

                <div className='col-12 mt-0'>
                    <div className='notice-alert'>
                        <div className='flex align-items-center'>
                            <i className='pi pi-info-circle mr-1 rev-dark-blue' />
                            <p className='notice-label'>{t("subscriber.notice")}</p>
                        </div>
                        <br />
                        <p className='payment-added-alert2'>
                            {subscribers.status === "CANCELLED" ? <Trans i18nKey={t("subscriber.modified-date")}
                                values={{ status: t("Cancelled"), date: cancelledDate }}
                                components={{ 1: <span className="cancelled-label" />, 2: <span className="rev-dark-blue" /> }} />
                                : subscribers.status === "FAILED" ? <Trans i18nKey={t("subscriber.modified-date")}
                                    values={{ status: t("Failed").toUpperCase(), date: failedDate }}
                                    components={{ 1: <span className="cancelled-label" />, 2: <span className="rev-dark-blue" /> }} />
                                    :
                                    subscribers.status === "PAUSED" ? <Trans i18nKey={t("subscriber.modified-date")}
                                        values={{ status: t("Paused"), date: pausedDate }}
                                        components={{ 1: <span className="paused-label" />, 2: <span className="rev-dark-blue" /> }} />
                                        :
                                        subscribers.status === "COMPLETE" ? <Trans i18nKey={t("subscriber.modified-date")}
                                            values={{ status: t("Completed"), date: completedDate }}
                                            components={{
                                                1: <span className="completed-label" />,
                                                2: <span className="rev-dark-blue" />
                                            }} />
                                            :
                                            <Trans i18nKey={t("subscriber.due_active")}
                                                values={{ value1: amount, value2: newDate }}
                                                components={{
                                                    1: <span className="active-label" />,
                                                    3: <span className="rev-dark-blue" />,
                                                    2: <strong className="rev-dark-blue" />
                                                }} />
                            }
                        </p>
                    </div>
                </div>

                <h6 className="title-tile mb-1 mt-1">{t("products.summary")}</h6>
                <div className='grid col-12 subscription-detail-stats-grid'>
                    <SmallCardTemplate summary={smallCardData} />
                </div>
                </section>
                <section className='col-12 xl:col-3 subscription-detail-sidebar'>
                {(defMembership.role !== "VIEWER" || props.showRecordPayment) && <div id="side-menu" className="subscription-detail-side-menu">
                    {defMembership.role !== "VIEWER" && props.showTriggerPayment &&
                        <div className="col-12">
                            <span onClick={props.onTriggerPayment}>
                                <i className="pi pi-dollar" />
                                {t('business_customers.collect_payment')}
                            </span>
                            <hr />
                        </div>
                    }

                    {props.showRecordPayment &&
                        <div className="col-12">
                            <span onClick={props.onRecordPayment}>
                                <i className="pi pi-book" />
                                {t('business_customers.record_pay')}
                            </span>
                            <hr />
                        </div>
                    }

                    {defMembership.role !== "VIEWER" && <>
                    {props.showChangeTarget &&
                        <div className="col-12">
                            <span onClick={props.onChangeTarget}>
                                <i className="pi pi-pencil" />
                                {t('subscriber.change_target')}
                            </span>
                            <hr />
                        </div>
                    }

                    {subscribers?.status === "PAUSED" ?
                        <div className="col-12">
                            <span onClick={() => {
                                props.setConfirmResume(true)
                                props.setState((state) => { return { ...state, resumed: true } })
                            }}>
                                <i className="pi pi-refresh" >
                                </i>{t('subscriber.resume_label')}
                            </span>
                            <hr />
                        </div> : ""}

                    {
                        subscribers?.status === "ACTIVE" &&
                        <div className="col-12">
                            <span onClick={() => {
                                props.setConfirmReschedule(true)
                            }}
                            >
                                <i className="pi pi-calendar" >
                                </i>{t('subscriber.reschedule_label')}
                            </span>
                            <hr />
                        </div>
                    }

                    {subscribers?.status === "ACTIVE" ?
                        <div className="col-12">
                            <span onClick={() => {
                                props.setConfirmPause(true)
                            }}
                            >
                                <i className="pi pi-pause" >
                                </i>{t('subscriber.pause_label')}
                            </span>
                            <hr />
                        </div> : ""}

                    {!["CANCELLED", "COMPLETE", "EXPIRED", "FAILED"].includes(subscribers?.status) && <>
                        <div className="col-12" >
                            < span onClick={() => {
                                props.setConfirmCancel(true)
                                props.setState((state) => { return { ...state, cancelled: true } })
                            }}>
                                <i className="pi pi-stop-circle" ></i>
                                {t('subscriber.cancel_label')}
                            </span>
                        </div>
                        <hr />
                    </>}

                    {props.showReassignPlan &&
                        <div className="col-12">
                            <span onClick={props.onReassignPlan}>
                                <i className="pi pi-sync" />
                                {t('subscriber.reassign_plan')}
                            </span>
                            <hr />
                        </div>
                    }
                    </>}
                </div>}
                </section>
            </div>
        </div>
    )
}
export default DetailCard